import { DonutChart } from "./components/donutChart/DonutChart.tsx";
import { BarChart } from "./components/barChart/BarChart.tsx";

export const CommunityInsights = () => {
  return (
    <div>
      <h5 className="hidden lg:inline">Community Insights</h5>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] mt-6 gap-6">
        <DonutChart />
        <BarChart />
      </div>
    </div>
  );
};
